import React from "react";

const Button = ({ name }) => {
  return <button>{name}</button>;
};

export default Button;
